import * as React from 'react';
import { apiGeneral, queryBuilder } from 'services/api';
import { optionsMapper, multiSelectorOptionsMapper } from './utils';
import { useQuery } from 'react-query';

type Carrier = {
  id: number;
  carrier_code: string | null;
  address_city: string | null;
  address_state: string | null;
  trade_name: string;
}

type CarrierOption = {
  value: string;
  label: string;
}

export const useCarrierOptions = () => {
  const fetchCarriers = React.useCallback(async (): Promise<CarrierOption[]> => {
    const queryParams = queryBuilder({
      all: 1,
    });

    const { data } = await apiGeneral.get<Carrier[]>(`/carriers?${queryParams}`);

    return data.map((carrier) => {
      const location = [carrier.address_city, carrier.address_state].filter(Boolean).join('/');
      const label = [carrier.trade_name, location].filter(Boolean).join(' - ');

      return {
        label,
        value: carrier.id.toString(),
      };
    });
  }, []);

  const carriersQuery = useQuery({
    queryFn: fetchCarriers,
    queryKey: 'fetch-carrier-options',
  });

  return {
    loading: carriersQuery.isLoading,
    singleSelectOptions: carriersQuery?.data
      ? carriersQuery.data.map(optionsMapper)
      : [],
    multiSelectOptions: carriersQuery?.data
      ? carriersQuery.data.map(multiSelectorOptionsMapper)
      : [],
  };
};